/** Tipos de corrida as every admin page labels them (docs/specs/trip-types.md). No API import: helpers and tests use it too. */
export type TripTypeLabel = { id: string; name: string; service: "ride" | "delivery"; icon: string; iconUrl: string | null; vehicleKind: "car" | "motorcycle"; active: boolean };

const names = new Map<string, TripTypeLabel>();

/** Replaces the known types (the shell loads them once; see `useTripTypeLabels`). */
export function setTripTypeLabels(list: readonly TripTypeLabel[]) {
  names.clear();
  for (const t of list) names.set(t.id, t);
}

/** "Conforto" for `conforto`; the id itself for a type this session doesn't know. */
export const typeLabel = (id: string | null | undefined) => (id ? (names.get(id)?.name ?? id) : "—");
export const typeInfo = (id: string) => names.get(id) ?? null;
export const isDeliveryType = (id: string) => names.get(id)?.service === "delivery";
/** Every type in display order (archived ones only when asked). */
export const allTypes = (opts: { archived?: boolean } = {}) => [...names.values()].filter((t) => opts.archived || t.active);
